import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideStore } from '@ngrx/store';
import { loadingInterceptor } from '@shared/services/loading/loading.interceptor';
import { routes } from './app.routes';
import { GlobalErrorHandler } from '@shared/services/errror-handling/global-error-handler.class';
import { organizationFeatureKey, organizationReducer } from '@features/organization/store';
import { schoolFeatureKey, schoolReducer } from '@features/school/store';
import { metaReducers } from '@core/store/meta-reducers';
import { APP_DATE_FORMATS } from '@shared/date-formats';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore({
      [schoolFeatureKey]: schoolReducer,
      [organizationFeatureKey]: organizationReducer,
    }, { metaReducers }),
    provideHttpClient(
      withInterceptors([loadingInterceptor])
    ),
    importProvidersFrom(MatDialogModule),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
};
